import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "onClick"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import OverlayTrigger from '../overlay/OverlayTrigger';
import Tooltip from '../tooltip/Tooltip';
var ACTIVE_CLASS_NAME = 'active';
var SELECTED_CLASS_NAME = 'selected';
var LABEL_TOOLTIP_DELAY = 1500;
var TreeSidebarCategories = function TreeSidebarCategories(_ref) {
  var children = _ref.children,
    currentCategoryId = _ref.currentCategoryId,
    onSelectCategory = _ref.onSelectCategory;
  return children.map(function (child) {
    var id = child.props.id;
    var icon = child.props.icon || '';
    var label = child.props.label;
    var statusClassName = classNames(currentCategoryId === id ? ACTIVE_CLASS_NAME : '', child.props.hasSelection && SELECTED_CLASS_NAME);
    var handleSelectCategory = function handleSelectCategory(event) {
      event.stopPropagation();
      onSelectCategory(id);
    };
    var category = /*#__PURE__*/React.createElement("li", {
      key: id,
      onClick: handleSelectCategory,
      className: statusClassName
    }, /*#__PURE__*/React.createElement("div", {
      className: 'selection-bubble'
    }, /*#__PURE__*/React.createElement("span", {
      className: "rioglyph ".concat(icon)
    })));
    if (label) {
      var tooltip = /*#__PURE__*/React.createElement("span", null, label);
      return /*#__PURE__*/React.createElement(OverlayTrigger, {
        key: "category-tooltip-".concat(id),
        placement: Tooltip.RIGHT,
        delayShow: LABEL_TOOLTIP_DELAY,
        overlay: /*#__PURE__*/React.createElement(Tooltip, {
          id: 'tooltip',
          width: 'auto'
        }, tooltip)
      }, category);
    }
    return category;
  });
};
var TreeSidebar = /*#__PURE__*/React.memo(function (props) {
  var className = props.className,
    onClick = props.onClick,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var classes = classNames('TreeSidebar', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("ul", {
    className: 'TreeSidebarNavigation',
    onClick: onClick
  }, /*#__PURE__*/React.createElement(TreeSidebarCategories, remainingProps)), /*#__PURE__*/React.createElement("div", {
    className: 'TreeSidebarToggle',
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: 'rioglyph rioglyph-chevron-left'
  })));
});
TreeSidebar.displayName = 'TreeSidebar';
TreeSidebar.defaultProps = {
  onClick: function onClick() {}
};
TreeSidebar.propTypes = {
  currentCategoryId: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.node),
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string
};
export default TreeSidebar;